import { ReactNode } from "react";
import { cn } from "../../utils/class-names";
import {
  PulseRow,
  row,
  RowContent,
  tokenLogoSize,
  useMarketLogoSize,
} from "./row-content";
import { Head } from "./head";
import { tv } from "tailwind-variants";

export const body = tv({
  base: "flex flex-col gap-0.5",
});

export const MarketsTable = {
  Root,
  Head,
  Body,
  body,
  row,
  RowContent,
  PulseRow,
  useMarketLogoSize,
  tokenLogoSize,
};

interface RootProps {
  className?: string;
  children?: ReactNode;
}

export function Root({ className, children }: RootProps): JSX.Element {
  return (
    <div className={cn("flex flex-col gap-0.5", className)}>{children}</div>
  );
}

interface BodyProps {
  className?: string;
  children?: ReactNode;
}

export function Body({ className, children }: BodyProps): JSX.Element {
  return <div className={body({ className })}>{children}</div>;
}
